class CartRecommendations {
  constructor() {
    this.container = document.getElementById('cart-recommendations');
    if (!this.container) return;
    document.addEventListener('cart:updated', this.handleCartUpdate.bind(this));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'product-form') {
          this.fetchByCollection();
        }
      });
    }
  }

  handleCartUpdate() {
    this.fetchByCollection();
  }

  async fetchByCollection() {
    try {
      const handle = window.currentProductCollection;
      const excludeId = window.currentProductId;

      if (!handle) {
        this.container.innerHTML = '';
        return;
      }

      const response = await fetch(`/collections/${handle}/products.json?limit=6`);
      if (!response.ok) {
        this.container.innerHTML = '';
        return;
      }
      const data = await response.json();

      if (!data.products || data.products.length === 0) {
        this.container.innerHTML = '';
        return;
      }

      const filtered = data.products
        .filter((p) => String(p.id) !== String(excludeId))
        .slice(0, 2);

      if (filtered.length === 0) {
        this.container.innerHTML = '';
        return;
      }

      this.render(filtered);
    } catch (err) {
      console.error('Error cargando recomendaciones:', err);
    }
  }

  render(products) {
    const itemsHtml = products
      .map((p) => {
        const variant = p.variants[0];
        const image = p.images && p.images[0] ? p.images[0].src : '';
        return `
      <div class="cart-recommendations__item">
        <a href="/products/${p.handle}">
          <img src="${image}" alt="${p.title}" loading="lazy">
          <p class="cart-recommendations__item-title">${p.title}</p>
          <p class="cart-recommendations__item-price">${this.formatMoney(variant.price)}</p>
        </a>
        <button class="cart-recommendations__add-btn" data-variant-id="${variant.id}">
          Añadir
        </button>
      </div>
    `;
      })
      .join('');

    this.container.innerHTML = `
      <p class="cart-recommendations__title">También te puede interesar</p>
      <div class="cart-recommendations__grid">${itemsHtml}</div>
    `;

    this.container.querySelectorAll('.cart-recommendations__add-btn').forEach((btn) => {
      btn.addEventListener('click', (e) => this.addToCart(e.target.dataset.variantId));
    });
  }

  formatMoney(amount) {
    return Number(amount).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  }

  async addToCart(variantId) {
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      window.location.reload();
    } catch (err) {
      console.error('Error añadiendo producto:', err);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => new CartRecommendations());